angular.module('picmonicng').directive('recentRecommendedBlock', [
  function () {
    return {
      restrict: 'E',
      templateUrl: '/templates/directives/recent-recommended-block.html',
      controller: [
        '$scope',
        'User',
        'Picmonics',
        'PlaylistService',
        'UserService',
        '$rootScope',
        'BrowseService',
        'Tracks',
        'MarketOptionsConfig',
        '$filter',
        'PicmonicQueue',
        '$state',
        'SpacedRep',
        'TokenService',
        'QuizService',
        '$modal',
        'ngBowser',
        'SplitTestService',
        'SpacedRepSettingsModal',
        '$cookies',
        function (
          $scope,
          User,
          Picmonics,
          PlaylistService,
          UserService,
          $rootScope,
          BrowseService,
          Tracks,
          MarketOptionsConfig,
          $filter,
          PicmonicQueue,
          $state,
          SpacedRep,
          TokenService,
          QuizService,
          $modal,
          ngBowser,
          SplitTestService,
          SpacedRepSettingsModal,
          $cookies
        ) {
          $scope.showContent = false;
          $scope.recentVisible = true;
          $scope.TokenService = TokenService;
          $scope.UserService = UserService;
          $scope.QuizService = QuizService;
          $scope.$cookies = $cookies;

          $scope.getSpacedRepStats = function () {
            timezone = moment.tz.guess();
            if (UserService.user.settings && !UserService.user.settings.timezone) {
              UserService.user.settings.timezone = timezone;
            }
            $scope.spacedRepStats = User.getv3({
              resource: 'spacedrepstats',
              timezone: timezone,
            });
          };
          $scope.getSpacedRepStats();

          // Listen for data change event
          $scope.$on('cardDataChanged', function (event, data) {
            UserService.getRecommendations();
            if (data.quiz_type === 'spacedrep') {
              $scope.getSpacedRepStats();
            }
          });

          if (UserService.user.playlist_mode == 'track') {
            if (UserService.user.current_track_id) {
              $scope.recentTrack = Tracks.get({
                track_id: UserService.user.current_track_id,
              });
              Tracks.get(
                {
                  track_id: UserService.user.current_track_id,
                  resource: 'picmonics',
                },
                function (data) {
                  $scope.recentTrackPicmonics = data.cards;
                }
              );
            }

            $scope.type = 'track';
          } else if (UserService.user.current_playlist) {
            $scope.recentTrack = null;
            $scope.type = 'playlist';

            if (typeof PlaylistService.playlists.$promise == 'undefined') {
              PlaylistService.init();
            }

            PlaylistService.initialPromise.$promise.then(function () {
              var currentPlaylist = $filter('filter')(
                PlaylistService.playlists,
                { playlist_id: UserService.user.current_playlist },
                true
              );
              if (currentPlaylist.length == 1) {
                $scope.recentTrack = currentPlaylist[0];
                $scope.recentTrackPicmonics = PlaylistService.getCards($scope.recentTrack);
              }
            });
          }

          $scope.spacedRepTileClick = function () {
            if ($scope.spacedRepStats.current_left > 0) {
              $scope.startSpacedRep();
            } else if ($scope.spacedRepStats.current_left == 0 && $scope.spacedRepStats.next > 0) {
              $scope.newSpacedRep();
            }
          };

          $scope.startSpacedRep = function ($event) {
            if ($event) {
              $event.stopPropagation();
            }

            $scope.$parent.visibleContent = 'recent';
            BrowseService.setOpen(false);
            SpacedRep.start($scope.spacedRepStats.next);
          };

          $scope.newSpacedRep = function () {
            User.savev3({ resource: 'spacedrep' }, function (result) {
              $scope.$parent.visibleContent = 'recent';
              SpacedRep.start(result.next);
            });
          };

          $scope.goToRecentTrack = function () {
            if ($scope.type == 'playlist') {
              BrowseService.go('app.playlist', {
                playlist_id: $scope.recentTrack.playlist_id,
              });
            } else {
              BrowseService.go('app.pathways.picmonics', {
                pathway_id: $scope.recentTrack.root_pathway_id,
                track_id: $scope.recentTrack.track_id,
              });
            }
          };

          $scope.resumeRecentTrack = function () {
            if ($scope.recentTrack.total) {
              if ($scope.type == 'playlist') {
                BrowseService.go('app.playlist', {
                  playlist_id: $scope.recentTrack.playlist_id,
                });
                PicmonicQueue.setAndPlay(
                  $scope.recentTrackPicmonics,
                  $scope.recentTrack.last_viewed_card_id,
                  null,
                  null,
                  $scope.recentTrack.playlist_id
                );
              } else {
                $scope.loadingButton = true;
                Tracks.get({ track_id: $scope.recentTrack.track_id }, function (track) {
                  var last_viewed_card_id = track.last_viewed_card_id;
                  Tracks.get(
                    {
                      track_id: $scope.recentTrack.track_id,
                      resource: 'picmonics',
                    },
                    function (trackpicmonics) {
                      BrowseService.go('app.pathways.picmonics', {
                        pathway_id: $scope.recentTrack.root_pathway_id,
                        track_id: $scope.recentTrack.track_id,
                      });
                      var last_viewed_card = $filter('filter')(trackpicmonics.cards, { id: last_viewed_card_id });
                      if (last_viewed_card.length > 0) {
                        PicmonicQueue.setAndPlay(
                          $scope.recentTrackPicmonics,
                          last_viewed_card[0].card_id,
                          null,
                          $scope.recentTrack.track_id
                        );
                      } else {
                        var ordered_cards = $filter('orderBy')(trackpicmonics.cards, 'sort_order');
                        PicmonicQueue.setAndPlay(
                          $scope.recentTrackPicmonics,
                          ordered_cards[0].card_id,
                          null,
                          $scope.recentTrack.track_id
                        );
                      }
                      $scope.loadingButton = false;
                    }
                  );
                });
              }
            }
          };

          $scope.openSettings = function () {
            var modal = SpacedRepSettingsModal.show();

            modal.result.then(function () {
              $scope.getSpacedRepStats();
            });
          };

          $scope.generateBreadCrumbs = function (item) {
            var buffer = '';
            var arrow_right = ' &rsaquo; ';

            if (item.root_pathway_pathway_type) {
              if (UserService.user && UserService.user.lead) {
                var config = MarketOptionsConfig.getMarketById(UserService.user.lead);
                var found = false;
                angular.forEach(config.sections, function (section) {
                  if (
                    section.pathway_type == item.root_pathway_pathway_type &&
                    section.curriculum == item.root_pathway_curriculum &&
                    !found
                  ) {
                    buffer += $filter('ucfirst')(section.name);
                    found = true;
                  }
                });
              } else {
                buffer += $filter('ucfirst')(item.root_pathway_pathway_type);
              }
            }

            if (item.root_pathway_name) {
              if (buffer.length) {
                buffer += arrow_right;
              }
              buffer += item.root_pathway_name;
            }

            return buffer;
          };

          // Onboarding tooltip for referrals
          if (
            !UserService.user.has_seen.onboarding_browse_reccomended_referral &&
            UserService.user.has_seen.course_manager_onboard &&
            UserService.user.cards_viewed >= 15 &&
            !UserService.user.is_trial &&
            ngBowser.isDesktop()
          ) {
            $scope.show_referral_onboarding = true;
            UserService.see('onboarding_browse_reccomended_referral');
          }
        },
      ],
    };
  },
]);
